import { FEATURE_STATUS_CHANGED, SEARCH_TEXT_CHANGED } from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FEATURE_STATUS_CHANGED:
            return {
                ...state,
                featured: action.payload,
            };

        case SEARCH_TEXT_CHANGED:
            return {
                ...state,
                searchText: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
